module.exports = __webpack_public_path__ + "static/industrial-453f615a1989706c05c4a0054f467e40.jpeg";